/* RAKAN coffee finder — sensory + precise.
   Q1 bitterness + Q2 sweetness -> grade together (client matrix):
     Rich = high bitter + mid sweet | Lux = low bitter + high sweet | Super = mid bitter + high sweet.
   Result panel  -> user picks roast (free, defaults وسط) then التحويج (the last step); add-to-cart resolves the variant.
   Retune GRADE_BY below; grade keys must exist as result blocks in the section. */
(function () {
  'use strict';
  const root = document.getElementById('rkSelector');
  if (!root) return;

  const cfgEl = document.getElementById('rkSelectorConfig');
  const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { results: {}, hints: { roast: {}, tahwig: {} } };
  const t = (window.RK_I18N && window.RK_I18N.t) ? window.RK_I18N.t : (k, fallback) => fallback;

  // bitterness x sweetness -> grade (anchors: Rich=high+mid, Lux=low+high, Super=mid+high)
  const GRADE_BY = {
    low:  { low: 'lux',  mid: 'lux',   high: 'lux'   },
    mid:  { low: 'rich', mid: 'super', high: 'super' },
    high: { low: 'rich', mid: 'rich',  high: 'rich'  }
  };
  const DEFAULT_ROAST = 'وسط';                                                  // roast is a free pick, defaults medium
  const DEFAULT_SIZE = '٢٥٠ جرام';

  const steps = root.querySelectorAll('[data-step]');
  const dots = root.querySelectorAll('[data-dot]');
  const lbl = root.querySelector('#rkProgressLbl');
  const roastPills = root.querySelectorAll('#rkRoastPills .r-pill');
  const tahwigPills = root.querySelectorAll('#rkTahwigPills .r-pill');
  const roastHint = root.querySelector('#rkRoastHint');
  const tahwigHint = root.querySelector('#rkTahwigHint');

  let currentResult = null;   // cfg.results[grade]
  let chosenBitter = null;
  let selRoast = null;
  let selTahwig = 'سادة';

  function dotIndex(step) {
    if (step === '1') return 1;
    if (step === 'result') return 3;
    return 2;
  }
  function show(step) {
    const n = dotIndex(step);
    steps.forEach(s => s.classList.toggle('active', s.dataset.step === step));
    dots.forEach(d => {
      const i = +d.dataset.dot;
      d.classList.toggle('active', i === n);
      d.classList.toggle('done', i < n);
    });
    if (lbl) lbl.textContent = step === 'result'
      ? t('sel_done', 'ظبّط بنّك')
      : (n === 1 ? t('sel_q1', 'سؤال ١ من ٢') : t('sel_q2', 'سؤال ٢ من ٢'));
  }

  // find a variant for the current roast+tahwig; prefer the default size, prefer available
  function findVariant(roast, tahwig) {
    if (!currentResult || !currentResult.variants) return null;
    const vs = currentResult.variants.filter(v => v.roast === roast && v.tahwig === tahwig);
    if (!vs.length) return null;
    return vs.find(v => v.size === DEFAULT_SIZE && v.available)
        || vs.find(v => v.size === DEFAULT_SIZE)
        || vs.find(v => v.available)
        || vs[0];
  }
  // which roasts actually exist for this grade (Rich has no غامق)
  function roastsAvailable() {
    if (!currentResult || !currentResult.variants) return [];
    return [...new Set(currentResult.variants.map(v => v.roast))];
  }

  function paintPrice() {
    const v = findVariant(selRoast, selTahwig);
    const priceEl = root.querySelector('#rkRPrice');
    if (priceEl) priceEl.textContent = v ? v.price : (currentResult && currentResult.variants[0] ? currentResult.variants[0].price : '');
    const buy = root.querySelector('#rkRBuy');
    if (buy) buy.disabled = !v || v.available === false;
  }

  function paintRoast() {
    const avail = roastsAvailable();
    roastPills.forEach(p => {
      const r = p.dataset.roast;
      const on = r === selRoast;
      const usable = avail.indexOf(r) !== -1;
      p.classList.toggle('is-on', on);
      p.hidden = !usable;
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (roastHint) roastHint.textContent = (cfg.hints && cfg.hints.roast && cfg.hints.roast[selRoast]) || '';
  }
  function paintTahwig() {
    tahwigPills.forEach(p => {
      const on = p.dataset.tahwig === selTahwig;
      p.classList.toggle('is-on', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (tahwigHint) tahwigHint.textContent = (cfg.hints && cfg.hints.tahwig && cfg.hints.tahwig[selTahwig]) || '';
  }

  function setResult(grade) {
    const p = cfg.results[grade] || cfg.results.super;
    if (!p) return;
    currentResult = p;
    const img = root.querySelector('#rkRImg');
    if (img) { img.src = p.img; img.alt = p.alt || p.title; }
    root.querySelector('#rkRName').textContent = p.title.replace(/\s*[٢١][٢٥][٥٠]?\s*جرام\s*$/, '').trim();
    root.querySelector('#rkRDesc').textContent = p.desc;
    const view = root.querySelector('#rkRView');
    if (view && p.url) view.href = p.url;

    // roast defaults to medium and is a free pick (never derived from sweetness); clamp to what the grade offers
    const avail = roastsAvailable();
    selRoast = avail.indexOf(DEFAULT_ROAST) !== -1 ? DEFAULT_ROAST : avail[0];
    selTahwig = 'سادة';
    paintRoast();
    paintTahwig();
    paintPrice();
    show('result');
  }

  root.querySelectorAll('[data-bitter]').forEach(b => b.addEventListener('click', () => {
    chosenBitter = b.dataset.bitter;
    show('2');
  }));
  root.querySelectorAll('[data-sweet]').forEach(b => b.addEventListener('click', () => {
    const byBitter = GRADE_BY[chosenBitter] || GRADE_BY.mid;
    const grade = byBitter[b.dataset.sweet] || 'super';
    setResult(grade);
  }));
  roastPills.forEach(p => p.addEventListener('click', () => { selRoast = p.dataset.roast; paintRoast(); paintPrice(); }));
  tahwigPills.forEach(p => p.addEventListener('click', () => { selTahwig = p.dataset.tahwig; paintTahwig(); paintPrice(); }));
  root.querySelectorAll('[data-back]').forEach(b => b.addEventListener('click', () => show(b.dataset.back)));
  root.querySelectorAll('[data-restart]').forEach(b => b.addEventListener('click', () => { chosenBitter = null; show('1'); }));

  const buy = root.querySelector('#rkRBuy');
  if (buy) buy.addEventListener('click', () => {
    const v = findVariant(selRoast, selTahwig);
    if (v && window.rkAddToCart) {
      window.rkAddToCart({ items: [{ id: v.id, quantity: 1 }] });
    } else if (v) {
      window.location.href = (currentResult.url || '') + '?variant=' + v.id;
    } else if (currentResult && currentResult.url) {
      window.location.href = currentResult.url;
    }
  });

  window.rkSelectorRefresh = function () { if (currentResult) paintPrice(); };
})();
